import { render } from "./MobileModule.vue?vue&type=template&id=18f89592&scoped=true"
import script from "./MobileModule.vue?vue&type=script&lang=js"
export * from "./MobileModule.vue?vue&type=script&lang=js"

import "./MobileModule.vue?vue&type=style&index=0&id=18f89592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f89592"]])

export default __exports__